import { Component, OnInit, ViewContainerRef } from '@angular/core';
import * as moment from 'moment';
import { Subject } from 'rxjs/internal/Subject';
import { LoginService } from 'src/app/services/login/login.service';
import { MemoService } from 'src/app/services/memo/memo.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { HeaderCommunicationService } from 'src/app/services/node/header-communication.service';
import { CabinetService } from 'src/app/services/office/cabinet.service';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Header } from 'src/app/utils/interfaces/new/header.interface';
import { LocalAuth } from 'src/app/utils/interfaces/new/localauth.interface';
import { Memo } from 'src/app/utils/interfaces/new/memo.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { Utilisateur } from 'src/app/utils/interfaces/new/utilisateur.interface';

@Component({
  selector: 'app-memos',
  templateUrl: './memos.component.html',
  styleUrls: ['./memos.component.scss']
})
export class MemosComponent implements OnInit {

  public currentUser: any;
  public getCurrentUser: Utilisateur;
  public accountName: string;
  public localAuth: LocalAuth;
  public memoColumnTable = [];
  public memoList: Paginated<Memo>;
  public memoTable: any = {};
  public hideNew: boolean = false;
  public hideProcessed: boolean = true;
  public hideDisabled: boolean = true;
  public refreshStream: Subject<any>;
  public filtre: Filtres = {
    perpage: 8,
    currentPage: 1
  };

  constructor(
    private loginService: LoginService,
    private modalService: ModalService,
    private _viewRef: ViewContainerRef,
    private memoService: MemoService,
    private cabinetService: CabinetService,
    private _send: HeaderCommunicationService,
    private _strUtilsSrv: StringUtilsService
  ) {
    const head: Header = {
      isBack: true,
      title: "Mémos",
      backPage: "home"
    };
    this._send.announceHeader(head);
  }

  ngOnInit(): void {
    this.refreshStream = new Subject();
    this.refreshStream.subscribe(async (event) => {
      if (event === "memo") {
        this.getMemos();
      }
    });

    this.getCurrentUser = this.loginService.getCurrentUser();
    this.localAuth = {
      utilisateur: this.getCurrentUser,
    }
    this.currentUser = this.loginService.findOneAuth(this.localAuth);

    this.getMemos();
    this.memoColumnTable = [
      { title: 'Date', data: 'creationDate' },
      { title: 'Créé par', data: 'auteur' },
      { title: 'Destinataire', data: 'destinataireName' },
      { title: 'Mémo', data: 'message' },
      { title: 'Statut', data: 'status' },
      { title: 'Traité par', data: 'processedBy' },
      { title: 'Modifié le', data: 'modificationDate' },
    ]
  }

  public async getMemos(): Promise<void> {
    this.memoList = await this.memoService.find(this.filtre, { hide_new: this.hideNew, hide_processed: this.hideProcessed, hide_disabled: this.hideDisabled });
    const cabinetDestinataire = await this.cabinetService.findCurrentCabinetDestinataire();

    this.accountName = this.currentUser.profil.qualite ? `${this.currentUser.profil.qualite} ${this.currentUser.utilisateur.nom.toLocaleUpperCase()}` : `${this._strUtilsSrv.uppercaseFirstCharString(this.currentUser.utilisateur.prenom)} ${this.currentUser.utilisateur.nom.toLocaleUpperCase()}`;
    for (const [index, memo] of this.memoList.objects.entries()) {
      let newDestinataire = [];
      let status: string[] = [];
      let processedBy = [];
      let currentModificationDate: moment.Moment;

      const authorName = cabinetDestinataire.filter((auteur) => memo.auteur === auteur.id).map((auteur) => (auteur.qualite ? `${auteur.qualite} ${auteur.nom.toLocaleUpperCase()}` : `${this._strUtilsSrv.uppercaseFirstCharString(auteur.prenom)} ${auteur.nom.toLocaleUpperCase()}`)).shift();
      for (let destinataire of memo.destinataires) {
        newDestinataire.push(destinataire.qualite ? `${destinataire.qualite} ${destinataire.nom.toLocaleUpperCase()} ` : `${this._strUtilsSrv.uppercaseFirstCharString(destinataire.prenom)} ${destinataire.nom.toLocaleUpperCase()} `);
        if (destinataire.disabled) {
          const destDate = moment(destinataire.modificationDate);
          if (!currentModificationDate || destDate.isAfter(currentModificationDate)) {
            currentModificationDate = destDate;
          }
          if (status.length <= 0 || status[0] === 'En cours') {
            status.splice(0);
            status.push('Archivé');
          }
          processedBy.push(destinataire.qualite ? `${destinataire.qualite} ${destinataire.nom.toLocaleUpperCase()} ` : `${this._strUtilsSrv.uppercaseFirstCharString(destinataire.prenom)} ${destinataire.nom.toLocaleUpperCase()} `);
        } else if (destinataire.processed) {
          const destDate = moment(destinataire.modificationDate);
          if (!currentModificationDate || destDate.isAfter(currentModificationDate)) {
            currentModificationDate = destDate;
          }
          if (status.length <= 0 || status[0] === 'En cours') {
            status.splice(0);
            status.push('Traité');
          }
          processedBy.push(destinataire.qualite ? `${destinataire.qualite} ${destinataire.nom.toLocaleUpperCase()} ` : `${this._strUtilsSrv.uppercaseFirstCharString(destinataire.prenom)} ${destinataire.nom.toLocaleUpperCase()} `);
        } else {
          if (status.length <= 0) {
            status.push('En cours');
          }
        }
        if (destinataire.modificationDate) {
          currentModificationDate = moment(destinataire.modificationDate);
        }
      }

      this.memoTable = {
        id: memo.id,
        creationDate: moment(memo.creationDate).format('DD/MM/yyyy'),
        auteur: authorName,
        destinataires: memo.destinataires,
        destinataireName: newDestinataire,
        message: memo.message,
        processedBy: processedBy,
        status: status,
        modificationDate: currentModificationDate ? currentModificationDate.format('DD/MM/YYYY à k:mm') : '',
      }
      this.memoList.objects[index] = this.memoTable;
    }
  }

  public async onSearch(event: any): Promise<void> {
    this.filtre.currentPage = 1;
    this.filtre.find = event;
    this.getMemos();
  }

  public async onChangePage(value: any): Promise<void> {
    this.filtre.currentPage = value;
    this.getMemos();
  }

  public refreshMemos() {
    this.getMemos();
  }

  public async openMemo(event: Memo) {
    this.modalService.openModalMemo(this._viewRef, 'Mémo', this.currentUser, event.destinataires, 'editPage', this.refreshStream, event);
  }
}
